// Multivariate Dependencies
import React from 'react';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var HtmlTextContent = function (_a) {
    var text = _a.text;
    return (
    // eslint-disable-next-line react/no-danger
    React.createElement("div", { dangerouslySetInnerHTML: { __html: text } }));
};
//# sourceMappingURL=HtmlTextContent.js.map